
var id = "UPT";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"UPT\">\n<style type=\"text/css\">\n\t#UPT .st0{fill:'';}\n</style>\n<path class=\"st0\" d=\"M74.1,33.7c0-3.7-2.1-3.7-4.6-3.7H24.8c-2.5,0-4.6,0-4.6,3.7s2.1,3.7,4.6,3.7h44.7C72,37.4,74.1,37.4,74.1,33.7\n\tz M24.8,64.3h17.8c2.5,0,4.6,0,4.6-3.7s-2-3.7-4.6-3.7H24.8c-2.5,0-4.6,0-4.6,3.7C20.2,64.3,22.2,64.3,24.8,64.3z M24.5,91.3h25.1\n\tc2.4,0,4.3,0,4.3-3.7s-1.9-4.7-4.3-4.7H24.5c-2.4,0-4.3,1-4.3,4.7S22.1,91.3,24.5,91.3z\" />\n<path class=\"st0\" d=\"M113.3,0H14.6C6.5,0,0,6.5,0,14.6v98.8c0,8.1,6.5,14.6,14.6,14.6h36.3c2.8,0,5.2,1.8,5.2-1.1\n\tc0.1-2.8-2.2-5.2-5-5.2H51H10.6c-5-3.6-4.3-5.9-4.3-8.3l0,0V10.6c0-2.4,1.9-4.3,4.3-4.3h106.8c2.4,0,4.3,1.9,4.3,4.3V68\n\tc0,2.8,2.3,5.1,5.1,5.1c2.8,0,1.1-2.3,1.1-5.1V14.6C127.9,6.5,121.4,0,113.3,0z\" />\n<path class=\"st0\" d=\"M115.4,105.5c-2.3-2.4-5-4.4-7.9-5.9c2.8-3.4,5.6-7.9,5.6-12.7c0-10.8-5.5-16.5-16-16.5s-16,5.8-16,16.5\n\tc0,5,2.9,9.6,5.9,13.1c-2.6,1.4-5.9,3.2-8,5.3c-4.5,4.5-7.5,10.3-8.7,16.5c-0.6,3.2-1.2,6.1,1.9,6.1c2.4,0,3.5-1.8,3.9-4.2\n\tc1.9-9.8,11.3-17.2,21.4-17.2s19.5,7.4,21.4,17.2c0.4,2.4,1.5,4.1,3.9,4.2c3.1,0,2.5-2.9,1.9-6.1C123.7,115.7,119.7,110,115.4,105.5\n\tL115.4,105.5z M97.1,96.1c-4.9,0-9-4.1-9-9.2s4-9.2,9-9.2s9,4.1,9,9.2S102.1,96.1,97.1,96.1z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
